import React from 'react';
import { styled } from '@compiled/react';
import { CustomThemeButton } from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

const ErrorUser = ({ onFetchUsers }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper role="alert">
			<Box xcss={errorMessageWrapperStyles}>{formatMessage(messages.cannotLoadUsers)}</Box>
			<ButtonWrapper>
				<CustomThemeButton
					appearance="link"
					spacing="none"
					onClick={(event) => {
						event.stopPropagation();
						onFetchUsers();
					}}
					theme={(currentTheme, theme) => {
						const buttonTheme = currentTheme(theme);
						return {
							...buttonTheme,
							buttonStyles: {
								...buttonTheme.buttonStyles,
								alignItems: 'center',
							},
						};
					}}
				>
					{formatMessage(messages.tryAgain)}
				</CustomThemeButton>
			</ButtonWrapper>
		</Wrapper>
	);
};

export default ErrorUser;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 5}px`,
	display: 'flex',
	alignItems: 'center',
	paddingTop: 0,
	paddingRight: token('space.150', '12px'),
	paddingBottom: 0,
	paddingLeft: token('space.150', '12px'),
	justifyContent: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonWrapper = styled.div({
	display: 'flex',
	flexGrow: 1,
	height: '100%',
});

const errorMessageWrapperStyles = xcss({
	marginRight: 'space.100',
});
